import React from 'react';

import { Text, TextProps } from '@reckon-web/text';
import { Inline } from '@reckon-web/inline';
import { makeId } from '@reckon-web/utils';

import { DateUtils } from '../../utils/date-utils';

export const DueDate: React.FC<{
  date: Date;
  prefix?: string;
  showDueDays?: boolean;
  showDate?: boolean;
  // this is used for two different size related props, so we can't reuse anything from balance
  size?: 'xsmall' | 'small';
  // this one is purely for the text elements, so can be whatever balance accepts
  weight?: TextProps['weight'];
  testId?: string;
}> = ({
  date,
  prefix,
  showDate = true,
  showDueDays,
  size = 'small',
  weight = 'medium',
  testId = `due-date`,
}) => (
  <Inline alignY="center" gap={size}>
    {showDate && (
      <Text
        size={size}
        weight={weight}
        data={{ testid: makeId(testId, 'date') }}
      >
        {prefix && `${prefix} `}
        {DateUtils.formatDateShort(date)}
      </Text>
    )}
    {showDueDays && (
      <Text
        size={size}
        weight={weight}
        color={new Date() > date ? 'critical' : 'muted'}
        data={{ testid: makeId(testId, 'overdue') }}
      >
        ({DateUtils.formatDueDays(date, 'overdue')})
      </Text>
    )}
  </Inline>
);
